// Centralised framer-motion configuration constants. Defining these objects
// at module scope (rather than inline JSX) avoids needlessly allocating new
// references on every render and keeps motion behaviour consistent across
// the application.

export const EASE_OUT = [0.2, 0.8, 0.2, 1];

// Section reveal (used by SectionReveal wrapper).
export const REVEAL_INITIAL = { opacity: 0, y: 14 };
export const REVEAL_WHILE_IN_VIEW = { opacity: 1, y: 0 };
export const REVEAL_VIEWPORT = { once: true, margin: '-60px' };

// Default reveal transition (no per-instance delay). For variable delays use
// `buildRevealTransition(delay)` which returns a memoisable object.
export const REVEAL_TRANSITION_BASE = { duration: 0.55, ease: EASE_OUT };
export const buildRevealTransition = (delay = 0) => ({
    duration: 0.55,
    ease: EASE_OUT,
    delay,
});

// Services grid card reveal.
export const CARD_INITIAL = { opacity: 0, y: 6 };
export const CARD_WHILE_IN_VIEW = { opacity: 1, y: 0 };
export const CARD_VIEWPORT = { once: true, margin: '-60px' };
export const buildCardTransition = (delay = 0) => ({
    duration: 0.4,
    delay,
    ease: EASE_OUT,
});

// Testimonials fade.
export const FADE_INITIAL = { opacity: 0, y: 10 };
export const FADE_ANIMATE = { opacity: 1, y: 0 };
export const FADE_EXIT = { opacity: 0, y: -6 };
export const FADE_TRANSITION = { duration: 0.5, ease: EASE_OUT };

// Insights image hover.
export const IMG_INITIAL = { scale: 1 };
export const IMG_HOVER = { scale: 1.03 };
export const IMG_TRANSITION = { duration: 0.7, ease: EASE_OUT };
export const IMG_FILTER_STYLE = { filter: 'saturate(0.92) brightness(0.92)' };
